
import type { PropType } from 'vue'

import { defineComponent } from 'vue'

import DwLoader from '@/modules/DispatcherWorkplaceModule/ui/DwLoader/index.vue'
import DwButton from '@/modules/DispatcherWorkplaceModule/ui/DwButton/index.vue'

export default defineComponent({
    components: {
        DwLoader,
        DwButton
    },
    props: {
        failed: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        loadingText: {
            type: [String, null] as PropType<string | null>,
            default: null
        },
    },
    setup() {
        const onReload = () => {
            if (window && window.location) {
                window.location.reload()
            }
        }

        return {
            onReload
        }
    }
})
